import { connect } from 'react-redux';
import { compose } from 'redux';
import * as Actions from '../../../redux/actions/';
import React, {useState} from "react";
import { Link/*, useRouteMatch*/ } from "react-router-dom";
import { auth } from "../../../firebase";
import SocialSignin from './social-signin';

const SignUp = ({setIsAuthenticating}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState(null);

	const createUserWithEmailAndPasswordHandler = async (event, email, password) => {
	  event.preventDefault();

		if (displayName === '') {
			setError({code: 'auth/invalid-display-name', message: 'The provided value for the displayName user property is invalid. It must be a non-empty string.'});
			return;
		}
		if (password.length < 6) {
			setError({code: 'auth/invalid-password', message: 'Password must be at least 6 characters.'});
			return;
		}
	  try {
			setIsAuthenticating(true);
			const {user} = await auth.createUserWithEmailAndPassword(email, password).catch((error) => {
				setIsAuthenticating(false);
				setError(error);
			});
			// this will kickoff an auth update so we can create a user profile that has a display name
			await user.updateProfile({
		    displayName: displayName
		  });
	  }
	  catch(error){
			setIsAuthenticating(false);
	    setError('Error Signing up with email and password');
	  }
	};

	const onChangeHandler = event => {
    const { name, value } = event.currentTarget;
    if (name === "userEmail") {
      setEmail(value);
    } else if (name === "userPassword") {
      setPassword(value);
    } else if (name === "displayName") {
      setDisplayName(value);
    }
  };

	const hasDisplayNameError = () => error && error.code === 'auth/invalid-display-name';
	const hasEmailError = () => {
		return (error && error.code === 'auth/invalid-email') ||
			(error && error.code === 'auth/email-already-in-use');
	};
	const hasPasswordError = () => {
		return (error && error.code === 'auth/weak-password') ||
			(error && error.code === 'auth/invalid-password');
	}

  return (
    <>
			<div className="auth-heading">
				<h1>Join us</h1>
			</div>
			<div className="form-element">
				<h2><label htmlFor="displayName" className="block"><b>*</b>Display Name:</label></h2>
				<div className={`input-wrap ${hasDisplayNameError() ? 'input-error' : null}`}>
					<input
						type="text"
						name="displayName"
						value={displayName}
						id="displayName"
						onChange={event => onChangeHandler(event)}
					/>
				</div>
				{ hasDisplayNameError() &&
					<div className="input-error-message">{error.message}</div>
				}
			</div>
			<div className="form-element">
				<h2><label htmlFor="userEmail" className="block"><b>*</b>Email:</label></h2>
				<div className={`input-wrap ${hasEmailError() ? 'input-error' : null}`}>
					<input
            type="email"
            name="userEmail"
            value={email}
            id="userEmail"
            onChange={event => onChangeHandler(event)}
          />
				</div>
				{ hasEmailError() &&
					<div className="input-error-message">{error.message}</div>
				}
			</div>
			<div className="form-element">
				<h2><label htmlFor="userPassword" className="block"><b>*</b>Password:</label></h2>
				<div className={`input-wrap ${hasPasswordError() ? 'input-error' : null}`}>
					<input
						type="password"
						name="userPassword"
						value={password}
						id="userPassword"
						onChange={event => onChangeHandler(event)}
					/>
				</div>
				{ hasPasswordError() &&
					<div className="input-error-message">{error.message}</div>
				}
			</div>
			<button
				className="primary"
				onClick={event => {
					createUserWithEmailAndPasswordHandler(event, email, password);
				}}
			>
				Sign up
			</button>
      <div className="auth-supplemental">
				<p>Already have an account?{" "}<Link to="/signin">Sign in here</Link></p>
        <SocialSignin />
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {}
}

//export default SignUp;
const mapDispatchToProps = {
	setIsAuthenticating: Actions.setIsAuthenticating
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps)
)(SignUp);
